export default {
   name: 'BadRequest',
   props: {
      station: {
         typ: String,
         required: true
      },
      user: {
         typ: String,
         required: true
      },
      endTime: {
         typ: Number,
         required: true
      },
      description: String,
      required: true
   },
   data() {
      return {
         modalopen: true,
         endDate: ''
      }
   },
   created() {
      this.convertDateTime()
   },
   methods: {
      convertDateTime() {
         let date = new Date(this.endTime * 1000)
         let lang = this.$i18n.locale + '-' + this.$i18n.locale.toUpperCase()
         const options = {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            timeZoneName: 'short'
         }
         this.endDate = date.toLocaleDateString(lang, options)
      },
      close() {
         this.modalopen = false
      },
      reload() {
         this.close()
         location.reload()
      }
   }
}
